"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var Row_1 = require("./Row");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Row_1).default; } });
